import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const customerAPI = createApi({
    reducerPath: "customerAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllCustomers: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `admin/customer?page=${page}&limit=${size}`;

                if (key) {
                    apiUrl += `&search=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["customers"],
        }),
        getSpecificCustomerDetails: builder.mutation({
            query: ({ id }) => {
                let apiUrl = `admin/customer/${id}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        createCustomer: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/customer",
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["customers"],
        }),
        updateCustomer: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/customer`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["customers"],
        }),
        deleteCustomer: builder.mutation({
            query: ({ id }) => {
                return {
                    url: `admin/customer/${id}`,
                    method: "DELETE"
                };
            },
            invalidatesTags: ["customers"],
        }),
        verifyCustomer: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/customer/verify",
                    method: "POST",
                    body: data
                };
            }
        }),
        switchActiveStateOfCustomer: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/customer/active`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["customers"],
        }),
        resetCustomerPassword: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/customer/reset-password",
                    method: "POST",
                    body: data
                };
            }
        }),

        syncCustomer: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/quickbook/customer/sync-by-time",
                    method: "POST",
                    body: data
                };
            }
        }),
    })
});

export const { 
    useGetAllCustomersMutation,
    useGetSpecificCustomerDetailsMutation,
    useCreateCustomerMutation,
    useUpdateCustomerMutation,
    useDeleteCustomerMutation,
    useVerifyCustomerMutation,
    useSwitchActiveStateOfCustomerMutation,
    useResetCustomerPasswordMutation,
    useSyncCustomerMutation
} = customerAPI;

export default customerAPI;